import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import styled from "styled-components";
import { Spinner, spinnerService } from '@chevtek/react-spinners';

const Btn = styled.button`
  background-color: ${props => props.bg};
  border: 2px solid ${props => props.bg};
  font: inherit;
  color: #fff;
  &:hover {
    background-color: transparent;
    cursor: pointer;
    color: ${props => props.bg};
    svg {
      fill: ${props => props.bg};
    }
  }

  ${props => props.customStyles}
`;

const A = styled.a`
  background-color: ${props => props.bg};
  border: 2px solid ${props => props.bg};
  color: #fff;
  &:hover {
    background-color: transparent;
    cursor: pointer;
    color: ${props => props.bg};
  }
`;

class NextStepButton extends React.Component {

  onClick = () => {
    if (!spinnerService.isShowing('buttonSpinner') || this.props.nextStepBtnLoading) {
      this.props.onClick();
    }
  }

  render() {
    const {
      baseColour,
      hideForMedium,
      showForMedium,
      text,
      loadingText,
      isLink,
      link,
      customStyles,
      nextStepBtnLoading
    } = this.props;

    return (
      <div
        className={classNames(
          "next_step_btn",
          { "show-for-medium": showForMedium },
          { "hide-for-medium": hideForMedium }
        )}
      >
        {isLink ? (
          <A bg={baseColour} href={link}>
            {text}
          </A>
        ) : (
          <Btn
             className="test_nextStepButton"
             customStyles={customStyles}
             bg={baseColour}
             onClick={this.onClick}>
            {nextStepBtnLoading ? loadingText : text }&nbsp;
            <Spinner name="buttonSpinner">
              <svg width="30" height="10" viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                  <circle cx="15" cy="15" r="15">
                      <animate attributeName="r" from="15" to="15"
                              begin="0s" dur="0.8s"
                              values="15;9;15" calcMode="linear"
                              repeatCount="indefinite" />
                      <animate attributeName="fill-opacity" from="1" to="1"
                              begin="0s" dur="0.8s"
                              values="1;.5;1" calcMode="linear"
                              repeatCount="indefinite" />
                  </circle>
                  <circle cx="60" cy="15" r="9" fill-opacity="0.3">
                      <animate attributeName="r" from="9" to="9"
                              begin="0s" dur="0.8s"
                              values="9;15;9" calcMode="linear"
                              repeatCount="indefinite" />
                      <animate attributeName="fill-opacity" from="0.5" to="0.5"
                              begin="0s" dur="0.8s"
                              values=".5;1;.5" calcMode="linear"
                              repeatCount="indefinite" />
                  </circle>
                  <circle cx="105" cy="15" r="15">
                      <animate attributeName="r" from="15" to="15"
                              begin="0s" dur="0.8s"
                              values="15;9;15" calcMode="linear"
                              repeatCount="indefinite" />
                      <animate attributeName="fill-opacity" from="1" to="1"
                              begin="0s" dur="0.8s"
                              values="1;.5;1" calcMode="linear"
                              repeatCount="indefinite" />
                  </circle>
              </svg>
            </Spinner>
          </Btn>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    baseColour: state.app.domain.BaseColour,
    nextStepBtnLoading: state.app.nextStepBtnLoading
  };
};

NextStepButton.defaultProps = {
  showForMedium: false,
  hideForMedium: false,
  onShow: false,
  text: "",
  link: "",
  isLink: false,
  customStyles: {}
};

export default connect(
  mapStateToProps,
  null
)(NextStepButton);
